import React, { useState, useEffect } from 'react'; // Added useEffect for the typewriter effect

// --- SwiperJS Imports ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';

// --- NEW/UPDATED IMAGE IMPORTS FOR MATERIAL GALLERY (Using up to 29) ---
import MaterialImage2 from '../../../assets/Images/Material2.jpg';
import MaterialImage3 from '../../../assets/Images/Material3.jpg';
import MaterialImage4 from '../../../assets/Images/Material4.jpg';
import MaterialImage6 from '../../../assets/Images/Material6.jpg';
import MaterialImage7 from '../../../assets/Images/Material7.jpg';
import MaterialImage8 from '../../../assets/Images/Material8.jpg';
import MaterialImage11 from '../../../assets/Images/Material11.jpg';
import MaterialImage12 from '../../../assets/Images/Material12.jpg';
import MaterialImage13 from '../../../assets/Images/Material13.jpg';
import MaterialImage14 from '../../../assets/Images/Material14.jpg';
import MaterialImage15 from '../../../assets/Images/Material15.jpg';
import MaterialImage16 from '../../../assets/Images/Material16.jpg';
import MaterialImage17 from '../../../assets/Images/Material17.jpg';
import MaterialImage18 from '../../../assets/Images/Material18.jpg';
import MaterialImage19 from '../../../assets/Images/Material19.jpg';
import MaterialImage20 from '../../../assets/Images/Material20.jpg';
import MaterialImage21 from '../../../assets/Images/Material21.jpg';
import MaterialImage22 from '../../../assets/Images/Material22.jpg';
import MaterialImage24 from '../../../assets/Images/Material24.jpg';
import MaterialImage25 from '../../../assets/Images/Material25.jpg';
import MaterialImage26 from '../../../assets/Images/Material26.jpg';
import MaterialImage27 from '../../../assets/Images/Material27.jpg';
import MaterialImage28 from '../../../assets/Images/Material28.jpg';


// --- Custom CSS for Animation, Styling, and Color Scheme (UPDATED for Typewriter) ---
const GalleryStyles = () => (
    <style>{`
      /* Base SwiperSlide styles */
      .gallery-marquee .swiper-slide {
        width: 320px;
        height: 384px;
        transition: transform 0.5s ease, opacity 0.5s ease;
        opacity: 0.5;
        transform: scale(0.85);
        border-radius: 0.75rem;
        overflow: hidden;
        position: relative;
      }
      /* Active SwiperSlide styles */
      .gallery-marquee .swiper-slide-active {
        opacity: 1;
        transform: scale(1);
      }
      /* Scrollbar hiding styles */
      .hide-scrollbar::-webkit-scrollbar { display: none; }
      .hide-scrollbar { 
        -ms-overflow-style: none;
        scrollbar-width: none;
      }

      /* -------------------------------------------------------- */
      /* 1. KEYFRAMES FOR CURSOR BLINKING */
      /* -------------------------------------------------------- */
      .typewriter-cursor {
          /* Black cursor to match default text color */
          border-right: 3px solid #333; 
          animation: blink-caret 0.75s step-end infinite;
      }
      
      @keyframes blink-caret {
          from, to { border-color: transparent }
          50% { border-color: #333; } /* Blink black */
      }
      
      /* 2. Header Text Styling (Typewriter + Swing animation adapted) */
      .gallery-headline {
          font-size: 3rem; 
          font-weight: 800; 
          color: #333; /* Default dark color */
          display: inline-block; 
          cursor: default;
          transition: color 0.3s ease;
          
          /* Typewriter-specific properties for desktop */
          white-space: nowrap; 
          overflow: hidden;
          margin-right: 5px; 
          
          /* Retained swing animation, but removed transform-origin for cleaner mobile behavior */
          animation: swing 4s ease-in-out infinite alternate;
      }
      
      /* 🌟 CRITICAL MOBILE FIX: Force text wrapping and reduce font size on small screens */
      @media (max-width: 639px) { 
          .gallery-headline {
              font-size: 1.75rem; /* Readable size for mobile */
              white-space: normal; /* THIS ENABLES TEXT WRAPPING (Fixes overflow) */
              overflow: visible; /* Allows the wrapped content to be displayed */
              width: 100%; /* Ensure it takes full width of the container for wrapping */
              animation: none; /* Disable swing animation on mobile for better stability */
          }
      }
      
      /* Header Hover Color Change */
      .gallery-headline:hover {
          color: #ff0000; /* Bright Red on hover */
      }
      
      /* When hovering the headline, we must change the cursor color too */
      .gallery-headline:hover .typewriter-cursor {
          animation: none; /* Stop the default black blink */
          border-right-color: #ff0000; /* Force it to red on hover */
      }
      
      /* Filter Button Styles (unchanged) */
      .gallery-filter-btn {
        background-color: #333; 
        color: white; 
        padding: 0.5rem 1rem;
        border-radius: 9999px;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        border: 2px solid #333;
        position: relative;
        overflow: hidden; 
      }
      
      .gallery-filter-btn::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #ff0000;
          transform: translateX(-100%);
          transition: transform 0.3s ease-in-out;
          z-index: 1;
      }

      .gallery-filter-btn:hover::after {
          transform: translateX(0);
      }
      
      .gallery-filter-btn:hover {
          color: white;
          border-color: #ff0000;
          transform: scale(1.05); 
      }

      .gallery-filter-btn.active, .gallery-filter-btn.active:hover {
        background-color: #ff0000;
        color: white;
        border-color: #ff0000;
        font-weight: bold;
        transform: scale(1.05); 
        z-index: 2;
      }

      .gallery-filter-btn.active::after {
          transform: translateX(0);
          z-index: -1; 
      }

      .gallery-filter-btn span {
          position: relative;
          z-index: 10;
      }
      
      /* 5. Creative Card Hover Border Animation (unchanged) */
      .gallery-card-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          cursor: pointer;
          overflow: hidden;
      }
      
      .gallery-card-wrapper::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 0%;
          height: 2px;
          background: #ff0000;
          transition: width 0.3s ease-out, height 0.3s ease-out 0.3s;
          z-index: 10;
      }
      
      .gallery-card-wrapper::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0%;
          height: 2px;
          background: #333;
          transition: width 0.3s ease-out 0.3s, height 0.3s ease-out;
          z-index: 10;
      }

      .gallery-card-wrapper:hover::before { width: 100%; height: 2px; }
      .gallery-card-wrapper:hover::after { width: 100%; height: 2px; }

      .gallery-card-wrapper-vertical-border-left, 
      .gallery-card-wrapper-vertical-border-right {
          content: "";
          position: absolute;
          width: 2px;
          height: 0%;
          transition: height 0.3s ease-out;
          z-index: 10;
      }
      
      .gallery-card-wrapper-vertical-border-left {
          top: 0;
          left: 0;
          background: #333;
      }
      
      .gallery-card-wrapper-vertical-border-right {
          bottom: 0;
          right: 0;
          background: #ff0000;
      }
      
      .gallery-card-wrapper:hover .gallery-card-wrapper-vertical-border-left, 
      .gallery-card-wrapper:hover .gallery-card-wrapper-vertical-border-right {
          height: 100%;
      }
      
      .gallery-card-wrapper img {
          transition: transform 0.5s ease;
      }
      .gallery-card-wrapper:hover img {
          transform: scale(1.05);
      }
      
    `}</style>
);

// --- UPDATED GALLERY DATA FOR MATERIALS ---
const galleryData = [
    { src: MaterialImage2, category: "stone" },
    { src: MaterialImage3, category: "stone" },
    { src: MaterialImage4, category: "stone" },
    { src: MaterialImage6, category: "wood" },
    { src: MaterialImage7, category: "wood" },
    { src: MaterialImage8, category: "metal" },
    { src: MaterialImage11, category: "fabric" },
    { src: MaterialImage12, category: "fabric" },
    { src: MaterialImage13, category: "fabric" },
    { src: MaterialImage14, category: "fabric" },
    { src: MaterialImage15, category: "texture" },
    { src: MaterialImage16, category: "texture" },
    { src: MaterialImage17, category: "texture" },
    { src: MaterialImage18, category: "texture" },
    { src: MaterialImage19, category: "finish" },
    { src: MaterialImage20, category: "finish" },
    { src: MaterialImage21, category: "finish" },
    { src: MaterialImage22, category: "finish" },
    { src: MaterialImage24, category: "other" },
    { src: MaterialImage25, category: "other" },
    { src: MaterialImage26, category: "other" },
    { src: MaterialImage27, category: "other" },
    { src: MaterialImage28, category: "other" },
];


const MaterialGallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    // --- State for Typewriter Effect ---
    const [typedText, setTypedText] = useState('');
    const [showCursor, setShowCursor] = useState(true);

    const fullHeadline = "Material Library: Textures That Tell a Story"; // The full text to type
    const typingSpeed = 75; // milliseconds per character

    // --- Typewriter Effect Logic (JS/React) ---
    useEffect(() => {
        let currentText = '';
        let index = 0;
        
        const timer = setInterval(() => {
            if (index < fullHeadline.length) {
                currentText += fullHeadline[index];
                setTypedText(currentText);
                index++;
            } else {
                clearInterval(timer);
                // Keep cursor visible after typing is complete
            }
        }, typingSpeed);

        // Separate interval for cursor blinking after typing finishes
        const cursorTimer = setInterval(() => {
             if (index >= fullHeadline.length) {
                // Only show the cursor if the text is complete
                setShowCursor(prev => !prev); 
             }
        }, 750); // Blinks at the same rate as the CSS blink-caret keyframe

        return () => {
            clearInterval(timer);
            clearInterval(cursorTimer);
        };
    }, [fullHeadline]);
    // --- End Typewriter Effect Logic ---


    const allItems = galleryData; 

    const openModal = (src) => {
        setSelectedImage(src);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage('');
    };

    return (
        <>
            <GalleryStyles /> {/* Inject the custom styles */}
            <section id="material-gallery" className="py-24 overflow-hidden">
                <div className="container mx-auto px-6">
                    <div className="text-center mb-12">
                        {/* HEADER TEXT with Typewriter implementation */}
                        <h2 className="gallery-headline headline-font">
                            {typedText}
                            {/* Conditionally show the blinking cursor span */}
                            {showCursor && <span className="typewriter-cursor"></span>}
                        </h2>

                        {/* UPDATED DESCRIPTION */}
                        <p className="text-xl mt-4 max-w-2xl mx-auto text-gray-700">A curated collection of our signature materials from luxury stone to high contrast finishes all utilized in our red, black, and white design language.</p>
                    </div>
                </div>

                <div className="hide-scrollbar">
                    <Swiper
                        modules={[Autoplay, EffectCoverflow]}
                        effect="coverflow"
                        loop={true}
                        grabCursor={true}
                        centeredSlides={true}
                        slidesPerView={'auto'}
                        spaceBetween={40}
                        speed={600} 
                        autoplay={{
                            delay: 2500, 
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true, 
                        }}
                        coverflowEffect={{
                            rotate: 0,
                            stretch: 0,
                            depth: 100,
                            modifier: 2,
                            slideShadows: false,
                        }}
                        className="gallery-marquee"
                    >
                        {allItems.map((item, index) => ( 
                            <SwiperSlide key={`material-${index}`} className="rounded-xl overflow-hidden"> 
                                <div 
                                    className="gallery-card-wrapper w-full h-full shadow-2xl"
                                    onClick={() => openModal(item.src)}
                                >
                                    <div className="gallery-card-wrapper-vertical-border-left"></div>
                                    <div className="gallery-card-wrapper-vertical-border-right"></div>
                                    
                                    <img src={item.src} className="w-full h-full object-cover" alt={`Material sample: ${item.category}`}/>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            {/* --- The Lightbox Modal --- */}
            {isModalOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
                    onClick={closeModal}
                >
                    <img 
                        src={selectedImage} 
                        alt="Enlarged material view" 
                        className="max-w-[90vw] max-h-[95vh] object-contain rounded-lg shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    />
                     <button 
                            className="absolute top-5 right-5 text-white text-4xl font-bold hover:text-red-500 transition-colors"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                </div>
            )}
        </>
    );
};

export default MaterialGallery;